import Vue from 'vue'
import Quasar, {Ripple, CloseOverlay, Notify, Dialog} from 'quasar-framework'

Vue.use(Quasar, {
    directives: [
        Ripple,
        CloseOverlay
    ],
    plugins: [
        Notify,
        Dialog
    ]
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/quasar.js